var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "certification",
    attrs: {
      "width": "500",
      "mask-closable": false,
      "title": $t("k2m4254", "验证单位")
    },
    on: {
      "on-cancel": _vm.clean
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('div', [_c('Button', {
          on: {
            "click": _vm.clean
          }
        }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
          attrs: {
            "type": "primary",
            "loading": _vm.modal.loading
          },
          on: {
            "click": _vm.onCommit
          }
        }, [_vm._v(` ${$t("l9122", "确认")} `)])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.modal.visible,
      callback: function ($$v) {
        _vm.$set(_vm.modal, "visible", $$v);
      },
      expression: "modal.visible"
    }
  }, [_vm.modal.visible ? _c('Form', {
    ref: "formCustom",
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "label-position": "top",
      "model": _vm.formObj,
      "rules": _vm.ruleCustom
    }
  }, [_c('div', {
    staticClass: "notice"
  }, [_vm._v(` ${$t("frdb6612", "注意：图片格式为'jpg、''jpeg、''png'，且图片大小不超过5M！")} `)]), _c('FormItem', {
    attrs: {
      "label": $t("pzdgbo6", "使用过的代码"),
      "prop": "originCode"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text"
    },
    on: {
      "on-change": _vm.onChangeOriginCode
    },
    model: {
      value: _vm.formObj.originCode,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "originCode", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObj.originCode"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("tqcx9e5", "营业执照号"),
      "prop": "blrn"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.formObj.blrn,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "blrn", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObj.blrn"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("gzxu0l4", "营业执照"),
      "prop": "blrnPicture"
    }
  }, [_c('UploadFile', {
    ref: "blrnPicture",
    attrs: {
      "code": "blrnPicture",
      "name": "files",
      "action": _vm.upload.action,
      "callback": _vm.upload.callback,
      "fileMaximum": 1,
      "defaultFileList": _vm.defaultFileListMap.blrnPicture,
      "headers": {
        authorization: 'DEV-PERM-TOKEN'
      }
    },
    on: {
      "on-change": _vm.onChangeFileList
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("jay7lk4", "门店图片"),
      "prop": "unitPicture"
    }
  }, [_c('UploadFile', {
    ref: "unitPicture",
    attrs: {
      "code": "unitPicture",
      "name": "files",
      "action": _vm.upload.action,
      "callback": _vm.upload.callback,
      "fileMaximum": 1,
      "defaultFileList": _vm.defaultFileListMap.unitPicture,
      "headers": {
        authorization: 'DEV-PERM-TOKEN'
      }
    },
    on: {
      "on-change": _vm.onChangeFileList2
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("e240qw4", "法人名称"),
      "prop": "corpn"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.formObj.corpn,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "corpn", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObj.corpn"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("k3zxro6", "法人联系电话"),
      "prop": "corpnTel"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.formObj.corpnTel,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "corpnTel", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObj.corpnTel"
    }
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };